(function () {
  function forceOpenFooterMenus(root = document) {
    const detailsEls = root.querySelectorAll('.widget--menu-column details');
    detailsEls.forEach((d) => {
      // offen erzwingen
      d.setAttribute('open', '');
      // Zuklappen via Tap verhindern (mobil)
      const s = d.querySelector('summary');
      if (s && !s.__forceOpenBound) {
        s.addEventListener('click', (e) => e.preventDefault(), true);
        s.style.pointerEvents = 'none';
        s.style.cursor = 'default';
        s.__forceOpenBound = true;
      }
      // Falls Theme-Skripte 'open' entfernen, sofort wieder setzen
      if (!d.__forceOpenObserver) {
        const mo = new MutationObserver((muts) => {
          muts.forEach((m) => {
            if (m.type === 'attributes' && m.attributeName === 'open' && !m.target.hasAttribute('open')) {
              m.target.setAttribute('open', '');
            }
          });
        });
        mo.observe(d, { attributes: true, attributeFilter: ['open'] });
        d.__forceOpenObserver = mo;
      }
    });
  }

  // 1) Initial beim ersten Laden
  document.addEventListener('DOMContentLoaded', () => forceOpenFooterMenus());

  // 2) Shopify-Section-Events (wenn Footer als Section neu gerendert wird)
  // -> feuert im Editor & bei section rendering
  document.addEventListener('shopify:section:load', (e) => forceOpenFooterMenus(e.target));
  document.addEventListener('shopify:section:reorder', (e) => forceOpenFooterMenus(e.target));
  document.addEventListener('shopify:section:select', (e) => forceOpenFooterMenus(e.target));
  document.addEventListener('shopify:block:select', (e) => forceOpenFooterMenus(e.target));

  // 3) AJAX-/PJAX-/Turbo-Navigationen diverser Themes
  // (wir hängen uns an gängige Events – es schadet nicht, mehrere zu unterstützen)
  ['turbo:load', 'turbolinks:load', 'page:load', 'pageshow'].forEach((ev) =>
    document.addEventListener(ev, () => forceOpenFooterMenus())
  );

  // 4) Falls Pinnacle eigene Events wirft, greifen wir sie ebenfalls ab
  // (Fuel Themes dokumentiert mehrere Custom Events)
  ['cart:item-added', 'line-item:change:end', 'quick-view:open', 'search:open'].forEach((ev) =>
    document.addEventListener(ev, () => forceOpenFooterMenus())
  );
})();
